export default __webpack_public_path__ + "static/media/horizontal_rebars.03b34913.svg";